import * as angular from 'angular';

// **************************************************************************************************
// You must include the Highcharts libraries  for this directive to work!
// **************************************************************************************************

// Given an object like this in the $scope:
//
//   $scope.example = function (input1, input2) {
//     if (we have enough data to create a chart) {
//       // Use our inputs to create a Highcharts configuration object and return that.
//       return highchartsConfigurationObject;
//     } else {
//       // If we don't have enough data to create a chart we should return null.
//       return null;
//     }
//   }
//
// And a directive like this in the HTML:
//   <div aptitude-macro-chart data="example(foo, bar)"></div>
//
// You will get a graph based on the output of the example function.
//
export default function AptMacroChart($log, chartGenerationService) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      data: '=aptMacroChart',
      zoom: '&?'
    },
    template: '<div class="graphContainer"><div></div></div>',
    replace: true,
    controller: function _aptMacroChartController($scope, $element, $attrs) {
      'ngInject';

      function displayGraph(target, data, callback) {
        // I hate that I have to do this, but the Highcharts chart is grabbing mouse clicks and not bubbling them up,
        // even in those cases where it does not have an event handler to process them. So I have to hook up an event
        // handler myself to invoke the same function that the zoom overlay invokes.
        // if (data != null && data.chart != null) {
        if (data != null) {
          // Why aren't we using the above version?
          if (callback) {
            if (data.chart.events) {
              data.chart.events.click = callback;
            } else {
              data.chart.events = {
                click: callback
              };
            }
          }

          target.highcharts(data);
        }
      }

      var $target = $($element.children()[0]);

      // This was ridiculously hard for some reason. If you use & to bind to a function in the parent scope from
      // within an isolated scope then AngularJS will always create a function and assign it in the $scope, even if
      // you made the attribute optional (that is, "&?"). So you can't test the $scope.zoom and expect to ever see it
      // undefined. There may be a function which _returns_ undefined, but there will always be a function bound
      // to the scope variable. Thus, to know if the user didn't define a value for the attribute, we have to use the
      // array of attributes to test.
      $scope.zoomOverlay = angular.isDefined($attrs.zoom);

      var generatedData = chartGenerationService.generateMacroChart(
        $scope.data.activePuck.microChartData,
        $scope.data.activeDataSet.overview.duration.targetPotentialMarketShare,
        $scope.data.activePuck.potentialMarketSharePercentage,
        $scope.data.benchmarks == 'all',
        $scope.data.benchmarks == 'likeMe',
        $scope.data.activePuck.benchmarksGraph.data.benchmarks
      );

      displayGraph($target, generatedData, null);

      // This watches for any changes in the bound data and immediately updates the chart in response to the change.
      $scope.$watch(
        'data',
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            if (newValue == null) {
              ($target as any).highcharts().destroy();
            } else {
              var generatedData = chartGenerationService.generateMacroChart(
                $scope.data.activePuck.microChartData,
                $scope.data.activeDataSet.overview.duration
                  .targetPotentialMarketShare,
                $scope.data.activePuck.potentialMarketSharePercentage,
                $scope.data.benchmarks == 'all',
                $scope.data.benchmarks == 'likeMe',
                $scope.data.activePuck.benchmarksGraph.data.benchmarks
              );

              displayGraph($target, generatedData, null);
            }
          }
        },
        true
      );
    }
  };
}
